const scoopyData = {
  slug: "scoopy",
  name: "Honda Scoopy",

  hero: {
    shortDescription:
      "Skutik fashionable dengan desain unik, teknologi modern, dan mesin 110cc irit bahan bakar",

    variants: [
      {
        key: "fashion-black",
        label: "Fashion",
        fullName: "Honda Scoopy Fashion Black",
        startPrice: 23584000,
      },
      {
        key: "prestige-red",
        label: "Prestige",
        fullName: "Honda Scoopy Prestige Red",
        startPrice: 24389000,
      },
      {
        key: "stylish-green",
        label: "Stylish",
        fullName: "Honda Scoopy Stylish Green",
        startPrice: 24389000,
      },
    ],

    slides: [
      {
        variantKey: "fashion-black",
        image: "/assets/motor/produk/scoopy/Honda-Scoopy-Fashion-Black.webp",
        specs: {
          engine: "109,5 cc",
          fuelInjection: "PGM-FI",
          smartKey: false,
        },
      },
      {
        variantKey: "prestige-red",
        image: "/assets/motor/produk/scoopy/Honda-Scoopy-Prestige-Red.webp",
        specs: {
          engine: "109,5 cc",
          fuelInjection: "PGM-FI",
          smartKey: true,
        },
      },
      {
        variantKey: "stylish-green",
        image: "/assets/motor/produk/scoopy/Honda-Scoopy-Stylish-Green-1.webp",
        specs: {
          engine: "109,5 cc",
          fuelInjection: "PGM-FI",
          smartKey: true,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda Scoopy hadir sebagai skutik fashionable dengan desain unik dan modern yang cocok untuk gaya hidup anak muda.",
      },
      {
        type: "paragraph",
        text:
          "Mengusung mesin 110cc eSP berteknologi PGM-FI, Scoopy menawarkan performa halus dan efisiensi bahan bakar tinggi.",
      },
      {
        type: "heading",
        text: "Desain Ikonik dan Modern",
      },
      {
        type: "paragraph",
        text:
          "Lampu utama LED berdesain unik serta bodi membulat menjadikan Honda Scoopy tampil berbeda di kelasnya.",
      },
      {
        type: "heading",
        text: "Fitur Praktis untuk Harian",
      },
      {
        type: "paragraph",
        text:
          "Dilengkapi USB charger, smart key system (pada tipe tertentu), dan bagasi luas untuk menunjang mobilitas sehari-hari.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Mesin", "4 Langkah, SOHC, eSP"],
      ["Kapasitas Mesin", "109,5 cc"],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Daya Maksimum", "6,6 kW / 7.500 rpm"],
      ["Torsi Maksimum", "9,3 Nm / 5.500 rpm"],
      ["Transmisi", "Otomatis, V-Matic"],
    ],

    rangka: [
      ["Tipe Rangka", "Underbone eSAF"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Lengan Ayun dengan Peredam Kejut Tunggal"],
      ["Rem Depan", "Cakram"],
      ["Rem Belakang", "Tromol"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.847 x 686 x 1.061 mm"],
      ["Jarak Sumbu Roda", "1.251 mm"],
      ["Tinggi Jok", "746 mm"],
      ["Berat", "94–95 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "4,2 Liter"],
      ["Kapasitas Bagasi", "15,4 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Panel Meter", "Digital"],
      ["Lampu", "Full LED"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda Scoopy",
    items: [
      {
        title: "Desain Fashionable",
        desc:
          "Tampilan ikonik dengan gaya modern yang khas Honda Scoopy.",
      },
      {
        title: "Mesin 110cc eSP",
        desc:
          "Performa halus dengan konsumsi bahan bakar sangat irit.",
      },
      {
        title: "Smart Key System",
        desc:
          "Sistem keyless untuk keamanan dan kemudahan (tipe Prestige & Stylish).",
      },
      {
        title: "USB Charger",
        desc:
          "Memudahkan pengisian daya perangkat elektronik saat berkendara.",
      },
      {
        title: "Rangka eSAF",
        desc:
          "Lebih ringan dan meningkatkan efisiensi berkendara.",
      },
      {
        title: "Lampu Full LED",
        desc:
          "Pencahayaan optimal dengan tampilan modern.",
      },
    ],
  },
};

export default scoopyData;
